import React from 'react';
import ComingSoon from './ComingSoon';

export default function CounterpartyDashboard() {
  return <ComingSoon title="Counterparties" />;
}

// CODIGO ORIGINAL COMENTADO PARA FUTURO USO
/*
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { mainService } from '../../services/api/main.service';
import { useQuery } from '@tanstack/react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { useWindow } from '../../context/WindowContext';
import { IsLoading } from '../../components/ui/isLoading';
// Types definition for the data structure

export default function CounterpartyDashboard_ORIGINAL() {
  const navigate = useNavigate();
  const { windowWidth } = useWindow();
  // Use React Query's state variables directly instead of duplicating state
  const { data: railCounterpartyData, isLoading, isError } = useQuery({
    queryKey: ['CounterpartiesData'],
    queryFn: () => mainService.getCounterpartiesData(),
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    refetchOnWindowFocus: false,
    refetchOnMount: true, // Always refetch when component mounts
  });

  // State hooks for UI controls (these are still needed)
  const [filter, setFilter] = useState<string>('ALL');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('table');
  useEffect(() => {
    if (windowWidth < 1440) {
      setActiveTab("cards");
    } else {
      setActiveTab("table");
    }
  }, [windowWidth])
  // Filter counterparties based on status and search term
  const getFilteredCounterparties = () => {
    if (!railCounterpartyData?.counterparties) return [];

    return railCounterpartyData.counterparties.filter(cp => {
      const matchesFilter = filter === 'ALL' || cp.counterparty_type === filter || cp.status === filter;
      const matchesSearch = cp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (cp.blockchain_address && cp.blockchain_address.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (cp.id && cp.id.includes(searchTerm));

      return matchesFilter && matchesSearch;
    });
  };

  // Truncate long strings like blockchain addresses
  const truncateString = (str: string, maxLength: number = 12): string => {
    if (!str || str.length <= maxLength) return str || '';
    return `${str.substring(0, maxLength / 2)}...${str.substring(str.length - maxLength / 2)}`;
  };

  // Get unique counterparty types for filter options
  const getCounterpartyTypes = (): string[] => {
    if (!railCounterpartyData?.counterparties) return [];

    const types = new Set<string>();
    railCounterpartyData.counterparties.forEach(cp => types.add(cp.counterparty_type));
    return Array.from(types);
  };

  // Get unique statuses for filter options
  const getStatuses = (): string[] => {
    if (!railCounterpartyData?.counterparties) return [];

    const statuses = new Set<string>();
    railCounterpartyData.counterparties.forEach(cp => statuses.add(cp.status));
    return Array.from(statuses);
  };

  // Calculate statistics
  const getStats = () => {
    if (!railCounterpartyData?.counterparties) return { crypto: 0, fiat: 0, active: 0, closed: 0, pending: 0 };

    const stats = {
      crypto: 0,
      fiat: 0,
      active: 0,
      closed: 0,
      pending: 0
    };

    railCounterpartyData.counterparties.forEach(cp => {
      if (cp.counterparty_type.includes('CRYPTO')) stats.crypto++;
      if (cp.counterparty_type.includes('FIAT')) stats.fiat++;

      if (cp.status === 'ACTIVE') stats.active++;
      else if (cp.status === 'CLOSED') stats.closed++;
      else if (cp.status.includes('PENDING')) stats.pending++;
    });

    return stats;
  };

  // Handle loading state
  if (isLoading) {
    return (
      <IsLoading />
    );
  }

  // Handle error state
  if (isError) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Error: </strong>
        <span className="block sm:inline">Failed to load counterparty data.</span>
      </div>
    );
  }

  // Handle no data state
  if (!railCounterpartyData) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Notice: </strong>
        <span className="block sm:inline">No counterparty data available.</span>
      </div>
    );
  }

  const filteredCounterparties = getFilteredCounterparties();
  const stats = getStats();


  return (
    <div className="max-w-6xl mx-auto sm:px-4 py-8">
      <div className="flex justify-between items-center mb-6 flex-wrap gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Counterparty Dashboard</h1>
        <div className="text-sm text-gray-500 flex w-full sm:w-auto">
          <button
            className="wallet-btn wallet-btn-sm sm:ml-3 w-full"
            onClick={() => navigate('/dashboard/counterparties/create')}
          >
            Add New
          </button>
          // <Link 
            to="/dashboard/counterparties/create"
            className="wallet-card-balance flex ml-6 text-black"
          >
          Add New
          </Link>
        </div>
      </div>
      // Filters      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-grow">
            <input
              type="text"
              placeholder="Search by name or address..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="w-full md:w-48">
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="ALL">All</option>
              <optgroup label="Type">
                {getCounterpartyTypes().map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </optgroup>
              <optgroup label="Status">
                {getStatuses().map(status => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </optgroup>
            </select>
          </div>

          // <div className="flex">
            <button 
              className={`px-4 py-2 rounded-l ${activeTab === 'table' ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              onClick={() => setActiveTab('table')}
            >
              Table
            </button>
            <button 
              className={`px-4 py-2 rounded-r ${activeTab === 'cards' ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              onClick={() => setActiveTab('cards')}
            >
              Cards
            </button>
          </div>
        </div>
      </div>

      // Results count      <div className="text-gray-500 mb-4">
        Showing {filteredCounterparties.length} of {railCounterpartyData.counterparties.length} counterparties
      </div>

      // Table View      {activeTab === 'table' && (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto p-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Asset</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address/Account</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Int'l</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rails</th>
                  <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredCounterparties.map(cp => (

                  <tr key={cp.id} className="hover:bg-gray-50">
                    <td className="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cp.name}</td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">{cp.counterparty_type}</td>
                    <td className="px-2 py-4 whitespace-nowrap">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                        ${cp.status === 'ACTIVE' ? 'bg-green-100 text-green-800' :
                          cp.status === 'CLOSED' ? 'bg-red-100 text-red-800' :
                            'bg-yellow-100 text-yellow-800'}`}>
                        {cp.status}
                      </span>
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">{cp.asset_type_id}</td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500" title={cp.blockchain_address || cp.id}>
                      {cp.blockchain_address ? truncateString(cp.blockchain_address, 16) :
                        cp.id ? truncateString(cp.id, 16) : 'N/A'}
                    </td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">{cp.is_international ? 'Yes' : 'No'}</td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">{cp.supported_rails.join(', ')}</td>
                    <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">
                      <Link
                        to={`/dashboard/counterparties/${cp.id}`}
                        className="flex ml-6 text-black items-center"
                      >
                        <Eye style={{ marginRight: '5px' }} size={16} /> Details
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      // Card View      {activeTab === 'cards' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {filteredCounterparties.map(cp => (
            <div key={cp.id} className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow">
              <div className="flex justify-between items-start mb-2">
                <h3 className="font-medium text-gray-900 mb-3">{cp.name}</h3>

                <Link
                  to={`/dashboard/counterparties/${cp.id}`}
                  className="flex text-black items-center"
                >
                  <Eye style={{ marginRight: '5px' }} size={16} /> Details
                </Link>
              </div>

              <div className="text-sm text-gray-500 mb-4">
                <div className="mt-1">
                  <span> Status • </span>
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full 
                  ${cp.status === 'ACTIVE' ? 'bg-green-100 text-green-800' :
                      cp.status === 'CLOSED' ? 'bg-red-100 text-red-800' :
                        'bg-yellow-100 text-yellow-800'}`}>
                    {cp.status}
                  </span>
                </div>

                <div className="mt-1">{cp.counterparty_type} • {cp.asset_type_id}</div>
                <div className="mt-1">{cp.is_international ? 'International' : 'Domestic'} • {cp.supported_rails.join(', ')}</div>
              </div>

              {(cp.blockchain_address || cp.id) && (
                <div className="text-xs bg-gray-100 p-2 rounded break-all">
                  <div className="font-medium text-gray-700 mb-1">
                    {cp.blockchain_address ? 'Blockchain Address:' : 'Account Number:'}
                  </div>
                  {cp.blockchain_address || cp.id}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {filteredCounterparties.length === 0 && (
        <div className="bg-gray-100 p-8 rounded-lg text-center text-gray-500">
          No counterparties found matching your criteria
        </div>
      )}
    </div>
  );
}
*/